import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Forms from "./forms";
import FieldCategoriesTranslations from "./fieldCategoriesTranslations";

const feature = "fieldCategoriesTranslations";

const InitialState = Record({
  forms: new Forms(),
  fieldCategoriesTranslations: new FieldCategoriesTranslations()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function FieldCategoriesTranslationsReducer(
  state = initialState,
  action
) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.fieldCategoriesTranslations
    ) {
      state = state.updateIn(["fieldCategoriesTranslations", "entities"], map =>
        map.mergeDeep(action.payload.entities.fieldCategoriesTranslations)
      );
    }
  }

  switch (action.type) {
    case actions.POST_FIELD_CATEGORIES_TRANSLATIONS: {
      return disableForm(state, "createFieldCategoriesTranslation");
    }
    case actions.POST_FIELD_CATEGORIES_TRANSLATIONS_SUCCESS: {
      state = clearForm(state, "createFieldCategoriesTranslation", Forms);
      return enableForm(state, "createFieldCategoriesTranslation");
    }
    case actions.POST_FIELD_CATEGORIES_TRANSLATIONS_ERROR: {
      state = enableForm(state, "createFieldCategoriesTranslation");
      return setFormErrors(
        state,
        "createFieldCategoriesTranslation",
        action.payload.errors
      );
    }

    case actions.PATCH_FIELD_CATEGORIES_TRANSLATION: {
      return state.setIn(["fieldCategoriesTranslations", "loading"], true);
    }
    case actions.PATCH_FIELD_CATEGORIES_TRANSLATION_SUCCESS: {
      return state.setIn(["fieldCategoriesTranslations", "loading"], false);
    }
    case actions.PATCH_FIELD_CATEGORIES_TRANSLATION_ERROR: {
      return state.setIn(["fieldCategoriesTranslations", "loading"], false);
    }

    case actions.DELETE_FIELD_CATEGORIES_TRANSLATION: {
      return state.deleteIn([
        "fieldCategoriesTranslations",
        "entities",
        action.payload.uid
      ]);
    }

    //case actions.GET_FIELD_CATEGORY_TRANSLATION_FIELDS: {
    //return state.setIn(["fieldCategoriesTranslations", "loading"], true);
    //}
    //case actions.GET_FIELD_CATEGORY_TRANSLATION_FIELDS_SUCCESS: {
    //state = state.setIn(
    //["fieldCategoriesTranslations", action.payload.uid, "fields"],
    //action.payload.result.fields
    //);
    //return state.setIn(["fieldCategoriesTranslations", "loading"], false);
    //}
    //case actions.GET_FIELD_CATEGORY_TRANSLATION_FIELDS_ERROR: {
    //return state.setIn(["fieldCategoriesTranslations", "loading"], false);
    //}

    case actions.POST_FIELD_CATEGORIES_TRANSLATION_SECTION: {
      return disableForm(state, "createFieldCategoriesTranslationSection");
    }
    case actions.POST_FIELD_CATEGORIES_TRANSLATION_SECTION_SUCCESS: {
      state = clearForm(
        state,
        "createFieldCategoriesTranslationSection",
        Forms
      );
      return enableForm(state, "createFieldCategoriesTranslationSection");
    }
    case actions.POST_FIELD_CATEGORIES_TRANSLATION_SECTION_ERROR: {
      state = enableForm(state, "createFieldCategoriesTranslationSection");
      return setFormErrors(
        state,
        "createFieldCategoriesTranslationSection",
        action.payload.errors
      );
    }

    case actions.SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_MODAL_VISIBLE: {
      return state.setIn(
        ["forms", "createFieldCategoriesTranslation", "isAddModalVisible"],
        action.payload.isVisible
      );
    }

    case actions.SET_IS_ADD_FIELD_CATEGORY_TRANSLATION_SECTION_MODAL_VISIBLE: {
      return state.setIn(
        [
          "forms",
          "createFieldCategoriesTranslationSection",
          "isAddModalVisible"
        ],
        action.payload.isVisible
      );
    }
  }

  return entitiesReducer(
    formsReducer(state, feature, action, Forms),
    feature,
    action
  );
}



// WEBPACK FOOTER //
// ./src/common/fieldCategoriesTranslations/reducer.js